import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'Store/InjectorsTypes';
import { initialState } from 'Slice/FeedIntentDataSlice';

// First select the relevant part from the state
const selectDomain = (state: RootState) => state?.feedIntentData || initialState;
export const selectIntentLoading = createSelector([selectDomain], (state) => state.intentLoading);
export const selectedIntentData = createSelector([selectDomain], (state) => state.intentData);
